module.exports = __webpack_public_path__ + "img/591059810.8c2ad43f.jpg";